import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import users from "./users";
import auth from "./auth";
import register from './register';
import customer from './customer';
import app from './app';

// main reducers
export const reducers = combineReducers({
  form: formReducer.plugin({
    "user_edit": (state, action) => {
      // reset form (wipe state) when navigating away from the User edit page
      switch(action.type) {
        case "@@router/LOCATION_CHANGE":
          return undefined;
        default:
          return state;
      }
    }
  }),
  users: users,
  auth: auth,
  register: register,
  customer: customer,
  app: app
});



// WEBPACK FOOTER //
// ./client/reducers/index.js